/// <amd-module name="NetSuite.LogoList.LogoListModule"/>
define("NetSuite.LogoList.LogoListModule", ["require", "exports", "NetSuite.LogoList.LogoListCCT", "NetSuite.LogoList.Common.Instrumentation.Helper"], function (require, exports, LogoListCCT, Instrumentation_Helper_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            Instrumentation_Helper_1.InstrumentationHelper.initializeInstrumentation(container);
            LogoListCCT.mountToApp(container);
        },
    };
});
